import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import {
    fetchingCampaigns,
    updateImagesLoaded,
    updateCategoryTabId,
    updateFilterTags,
} from './actions';

export const reducer = reducerWithInitialState(initialState)
    .case(fetchingCampaigns.started, state => ({
        ...state,
        loading: true,
    }))
    .case(
        fetchingCampaigns.done,
        (
            state,
            {
                result: {
                    openCampaigns,
                    upcomingCampaigns,
                    tabs,
                    showstoppers,
                    globalRetailEvents,
                },
            },
        ) => ({
            ...state,
            openCampaigns,
            upcomingCampaigns,
            globalRetailEvents,
            tabs,
            showstoppers,
            loading: false,
        }),
    )
    .case(fetchingCampaigns.failed, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    }))
    .case(updateImagesLoaded, (state, payload) => ({
        ...state,
        imagesLoaded: payload,
    }))
    .case(updateCategoryTabId, (state, payload) => ({
        ...state,
        categoryTabId: payload,
    }))
    .case(updateFilterTags, (state, payload) => ({
        ...state,
        filterTag: payload,
    }));

export default reducer;
